import React, { ReactNode } from "react";
import { LayoutHOCProps, TabProps } from "../../../types";

const nav = `.`;

const Tab: React.FC<TabProps> = ({ className, label, ribbon, isActive, onClick }) => {
  return (
    <div
      className={`col ${className} ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      {ribbon && (
        <div className="ribbon-customization">
          <span>soon</span>
        </div>
      )}
      {label}
    </div>
  );
};

const LayoutHOC: React.FC<LayoutHOCProps> = ({ mainContent, header = true, onTabChange, activeTab }) => {
  const tabs = [
    { className: "welcome", label: "welcome" },
    { className: "tagline", label: "tagline" },
    { className: "carousel", label: "carousel" },
    { className: "banner-landscape", label: "landscape banner" },
    { className: "side-by-side", label: "side by side" },
    { className: "values", label: "values" },
    { className: "banner-split", label: "split banner" },
    // { className: "central-categories", label: "2 categories", ribbon: true },
  ];

  return (
    <>
      {header && (
        <div className="header container text-center">
          <div className="row align-items-start">
            {tabs.map((tab) => (
              <Tab
                key={tab.className}
                className={tab.className}
                label={tab.label}
                // ribbon={tab.ribbon}
                isActive={activeTab === tab.className}
                onClick={() => onTabChange(tab.className)}
              />
            ))}
          </div>
        </div>
      )}
      <div className="customization-tool-body">{mainContent}</div>
    </>
  );
};

export default LayoutHOC;
